goog.provide("shadow.js.shim.module$$embedpdf$react$render");
goog.provide("module$shadow_js_shim_module$$embedpdf$react$render");
shadow.js.shim.module$$embedpdf$react$render = shadow.js.nativeProvides["@embedpdf/react/render"] = shadow$bridge("@embedpdf/react/render");
module$shadow_js_shim_module$$embedpdf$react$render.default = shadow.js.shim.module$$embedpdf$react$render;
